import React from "react";
import styled, { css } from "styled-components";
import { colors } from "../../styles";

const Select = styled.select`
  display: inline-block;
  width: 100%;
  background-color: ${colors.white};
  border: solid 2px ${colors.lightGray};
  border-radius: 5px;
  padding: 15px;
`;

const Subtext = styled.div`
  text-align: right;
  font-size: 0.8em;
  color: ${colors.darkGray};
`;

function InputSelect({ children, placeholder, subtext, ...props }) {
  return (
    <div style={{ width: "100%" }}>
      <Select {...props}>
        {placeholder && (
          <>
            <option value="">{placeholder}</option>
            <option value="">--------------</option>
          </>
        )}
        {children}
      </Select>
      {subtext && <Subtext>{subtext}</Subtext>}
    </div>
  );
}

export default InputSelect;
